import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import { topBidsForSlugs, type TopBid } from "@/lib/auctions.functions";

/**
 * Hämtar ledande bud för de auktionsannonser som syns i en lista.
 * En förfrågan för hela listan – inte en per kort.
 */
export function useTopBids(ads: { slug: string; sale_kind?: string | null }[]) {
  const load = useServerFn(topBidsForSlugs);
  const slugs = useMemo(
    () =>
      ads
        .filter((a) => a.sale_kind === "auction")
        .map((a) => a.slug)
        .slice(0, 60)
        .sort(),
    [ads],
  );

  const { data } = useQuery({
    queryKey: ["top-bids", slugs.join(",")],
    queryFn: () => load({ data: { slugs } }),
    enabled: slugs.length > 0,
    refetchInterval: 30_000,
  });

  return useMemo(() => {
    const map = new Map<string, TopBid>();
    for (const row of data ?? []) map.set(row.slug, row);
    return map;
  }, [data]);
}
